import { projektGajaChapters } from './content';
export const projektGajaQuickReference = projektGajaChapters.find((chapter) => chapter.title.toLocaleUpperCase('pl').includes('QUICK REFERENCE'));
